import { render, staticRenderFns } from "./GeneralSituationInstitutions.vue?vue&type=template&id=6c003aee&scoped=true"
import script from "./GeneralSituationInstitutions.vue?vue&type=script&lang=js"
export * from "./GeneralSituationInstitutions.vue?vue&type=script&lang=js"
import style0 from "./GeneralSituationInstitutions.vue?vue&type=style&index=0&id=6c003aee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c003aee",
  null
  
)

export default component.exports